// extracted by mini-css-extract-plugin
module.exports = {"headerbg":"Header_headerbg__2Fj6R","flexitems":"Header_flexitems__1pec3","navbarCss":"Header_navbarCss__3B4Lt"};